export class User {
  id: "";
  about: "";
  name: "";
  email: "";
  password: "";
  role: { id: ""; value: "" };
  job_title: "";
  phone: "";
  facebook_url: "";
  twitter_url: "";
  instagram_url: "";
  uploader: {};
  brokerCompany: "";
  can_manage_payment_plan = false;
  can_export = false;
  can_import = false;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/dtos/user.viewmodel.ts